module.exports = __webpack_public_path__ + "img/sva_logo.10dee8f7.png";